export const HOME = '/';
export const ABOUT_US = '/aboutUs';
export const BLOG = '/blog.fxblooms.com';
export const HOW_IT_WORKS = 'howItWorks';
export const CONTACT_US = '/contactUs';
export const SIGN_UP = '/user/signUp';
export const LOGIN = '/user/login';
export const ADD_USERNAME = '/user/addUsername';
export const FORGOT_PASSWORD = '/user/forgotPassword';
export const RESET_PASSWORD = '/user/resetPassword';
export const TERMS = '/termsAndConditions';
export const PRIVACY_POLICY = '/privacyPolicy';
export const USER_AGREEMENT = '/userAgreement';
export const FAQS = '/frequentlyAskedQuestions';
export const DISCLAIMER = '/disclaimer';
export const VERIFY_EMAIL = '/user/VerifyEmail';
export const PENDING_VERIFICATION = '/user/pendingVerification';
export const SETUP_2FA = '/user/twoFactor';
export const VERIFY_2FA = '/user/twoFactor/verify';
export const SIGNUP_SUCCESS = '/user/verificationSuccess';
export const SIGNUP_FAILURE = '/user/verificationFailure';

export const ADMIN_LOGIN = '/login/admin';
export const ADMIN_DASHBOARD = `/admin`;
export const ADMIN_HOME = `${ADMIN_DASHBOARD}/dashboard`;
export const CUSTOMERS = `${ADMIN_DASHBOARD}/customers`;
export const LISTINGS = `${ADMIN_DASHBOARD}/listings`;
export const TRANSACTION_LISTS = `${ADMIN_DASHBOARD}/transactions`;
export const DEPOSITS = `${ADMIN_DASHBOARD}/deposits`;
export const WITHDRAWALS = `${ADMIN_DASHBOARD}/withdrawals`;
export const FXBACCOUNTS = `${ADMIN_DASHBOARD}/fxbaccounts`;
export const PAYMENT_AUTHORIZATION = `${ADMIN_DASHBOARD}/withdrawals/paymentAuthorization`;
export const HISTORY = `${ADMIN_DASHBOARD}/history`;
export const SUPPORT = `${ADMIN_DASHBOARD}/support`;
export const RISK_PROFILE = `${ADMIN_DASHBOARD}/riskProfile`;

export const DASHBOARD = '/dashboard';
export const DASHBOARD_HOME = `${DASHBOARD}/home`;
export const EDIT_LISTING = `${DASHBOARD}/listings/edit`;
export const USER_DETAILS = `${DASHBOARD}/listings/sellerDetails`;
export const NOTIFICATIONS = `${DASHBOARD}/notifications`;
export const HOW_IT_WORKS_DASHBOARD = `${DASHBOARD}/howItWorks`;
export const WALLETS = `${DASHBOARD}/wallets`;
export const WALLET_TRANSACTION_STATUS = `${WALLETS}/transactionStatus`;
export const FUND_WALLET = `${WALLETS}/fundWallet`;
export const FUND_CONFIRMATION = `${WALLETS}/fundingRequest`;
export const FUND_AUTHORIZATION_SUCCESS = `${WALLETS}/fundingAuthorizationSuccess`;
export const FUNDING_FAILURE = `${WALLETS}/fundingFailure`;
export const FUNDING_REQUEST_STATUS = `${WALLETS}/funding/Status`;
export const REQUEST_WITHDRAWAL = `${WALLETS}/withdrawalRequest`;
export const WITHDRAWAL_REQUEST_STATUS = `${WALLETS}/withdrawal/status`;
export const VERIFF = `${DASHBOARD}/veriff`;
export const ACCOUNT = `${DASHBOARD}/account`;
export const PROFILE = `${DASHBOARD}/profile`;
export const SECURITY = `${DASHBOARD}/security`;
export const ID_VERIFICATION = `${SECURITY}/idVerification`;
export const PIN = `${SECURITY}/pin`;
export const TWO_FACTOR = `${SECURITY}/twoFactor`;
export const BANK_ACCOUNTS = `${DASHBOARD}/bankAccounts`;
export const TRANSACTIONS = `${DASHBOARD}/transactions`;
export const TRANSACTION_STATUS = `${TRANSACTIONS}/status`;
export const LOGOUT = '/logout';